import NextImage from 'next/image';

import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: 31rem;
  width: 100%;
  max-height: 39.25rem;
  margin: 7vh auto 1rem auto;
  background: ${({ theme }) => theme.tokens.colors.neutral[200]};
  box-shadow: 0px 40px 60px -15px rgba(0, 0, 0, 0.4);
  border-radius: 12px;
`;

export const Title = styled.h2`
  margin: 0;
  padding: 0.5rem;
  background: ${({ theme }) => theme.tokens.colors.neutral[100]};
  color: #2d2d30;
  font-size: 1.1rem;
  font-weight: 600;
  line-height: 1.25rem;
  text-align: center;
  border-radius: 12px 12px 0 0;
`;

export const CoverAndAvatarHolder = styled.div`
  position: relative;
  height: 10.5rem;
`;

export const AvatarImage = styled(NextImage)`
  position: absolute;
  bottom: -1.75rem;
  left: 3.5rem;
  border-radius: 50%;
  width: 5rem;
  height: 5rem;
  border: solid 4px ${({ theme }) => theme.tokens.colors.neutral[100]};
`;
